import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as lodash from 'lodash';
import { cloneDeep } from 'lodash';
import { MaintenanceActions } from './maintenance.action';
import { Maintenance, MaintenanceList, MaintenanceSortState } from '../../type/maintenance/maintenance.type';
import { MaintenanceCollection } from '../../collection/maintenance/maintenance.collection';
import { concatList } from '../root.reducer';

export type MaintenanceState = {
  maintenance: Maintenance | null;
  list: MaintenanceList[] | null;
  sort: MaintenanceSortState;
  isSortInit: boolean;
};

const initialState: MaintenanceState = {
  maintenance: null,
  list: null,
  sort: MaintenanceCollection.initialSortState,
  isSortInit: false,
};

export const MaintenanceReducer = reducerWithInitialState<MaintenanceState>(initialState)
  .case(MaintenanceActions.setMaintenance, (state, payload) => ({
    ...state,
    maintenance: lodash.cloneDeep(payload),
  }))
  .case(MaintenanceActions.setList, (state, payload) => ({
    ...state,
    list: lodash.cloneDeep(payload),
  }))
  .case(MaintenanceActions.setConcatList, (state, payload) => ({
    ...state,
    list: cloneDeep(concatList(state.list, payload)),
  }))
  .case(MaintenanceActions.setSort, (state, payload) => ({
    ...state,
    sort: payload ? lodash.cloneDeep({
      ...state.sort,
      ...payload,
    }) : MaintenanceCollection.initialSortState,
  }))
  .case(MaintenanceActions.setInitSort, (state, payload) => ({
    ...state,
    sort: MaintenanceCollection._initialSortState(payload),
  }))
  .case(MaintenanceActions.setIsInitSort, (state, payload) => ({
    ...state,
    isSortInit: cloneDeep(payload),
  }))
  .case(MaintenanceActions.resetState, () => initialState)
  .default((state) => state);
